import {
  HStack,
  Spinner as ChakraSpinner,
  SpinnerProps,
  Stack,
  Text,
} from '@chakra-ui/react'
import React from 'react'

export const Spinner = React.forwardRef<
  HTMLSpanElement,
  Omit<SpinnerProps, 'borderWidth'>
>(function Spinner(props, ref) {
  return (
    <ChakraSpinner
      ref={ref}
      {...props}
      color="colorPalette.500"
      borderBottomColor="colorPalette.200"
      borderWidth="4px"
    />
  )
})

type MessageSpinnerProps = {
  size?: 'md' | 'lg'
  variant?: 'skeleton' | 'subtle'
}

export const MessageSpinner = function MessageSpinner({
  size = 'md',
  variant = 'skeleton',
}: MessageSpinnerProps) {
  const spinnerSize = size === 'md' ? '28px' : '42px'
  const bgColor = variant === 'skeleton' ? undefined : 'blue.500/8'

  return size === 'md' ? (
    <HStack
      px={2}
      py={1}
      gap={2}
      width="fit-content"
      borderRadius="base"
      bgColor={bgColor}
    >
      <Spinner
        css={{
          '--spinner-size': spinnerSize,
        }}
      />
      <Text color="blue.500">読み込み中…</Text>
    </HStack>
  ) : (
    <Stack
      p={6}
      gap={4}
      justifyContent="center"
      alignItems="center"
      width="fit-content"
      borderRadius="base"
      bgColor={bgColor}
    >
      <Spinner
        css={{
          '--spinner-size': spinnerSize,
        }}
      />
      <Text color="blue.500">読み込み中…</Text>
    </Stack>
  )
}
